<template>
  <div id="partners">
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-8">
            <h2 class="display-3">Ils nous font confiance</h2>
            <p class="lead text-muted">
              Plusieurs particuliers, entreprises et agences de communication
              nous font confiance pour le déploiement et le suivie de leurs
              campagnes publicitaire.
            </p>
          </div>
        </div>

        <div class="row text-center mr-auto ml-auto justify-content-center">
          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/logo-celtiis.jpg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo celtiis benin, le réseau GSM 100% béninois"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/isocel.png'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo isocel telecom, le pouvoir de la fibre"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/superL.jpg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo moov africa bénin"
              />
            </div>
          </div>
          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/sunu.png'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo sunu assurances bénin"
              />
            </div>
          </div>
          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/moov/moov.jpg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo moov africa bénin"
              />
            </div>
          </div>

          <div class="mb-5 mb-lg-5" data-aos="fade-up" data-aos-duration="900">
            <div class="px-4">
              <img
                v-lazy="'img/theme/logo-woodin.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo woodin bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/aabVie.jpg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo Atlantique assurance bénin vie"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/agp.jpg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo moov africa bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/nsia.png'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo NSIA Assurance bénin"
              />
            </div>
          </div>
          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1100"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/kaweru.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo kaweru group cotonou barbecue bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/lapaire.png'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo lapaire les lunettes"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/aya.png'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo aya huile végétale bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/centrale.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo la centrale company bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/waccs.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo WACCS agence de communication au bénin"
              />
            </div>
          </div>

          <!-- <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/reseau.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo réseau pub agence de communication au bénin"
              />
            </div>
          </div> -->

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/smart.png'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo smart land africa"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/fewu.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo lapaire les lunettes"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/oremi.png'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo de Oremi Atlantique Assurance bénin"
                style="object-fit: contain"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/genesis.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo chips yoyo bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/yoyo.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo chips yoyo bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/nobila.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo Nobila aiport hôtel bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="2500"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/book.jpg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo bookonnet bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="2500"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/hydrokeke.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo hydrokeke le vélo sur l'eau au bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="2500"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/toura.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo toura corp agence de tourisme au bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/purethnik.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo purethnik bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/assouka.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo Assouka bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="1700"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/lba.png'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo les bonnes affaires bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-right"
            data-aos-duration="1900"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/beautifulldarkness.jpg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo de beautifulldarkness"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="2100"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/rato.png'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo de rato bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="2200"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/amazone.jpg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo de megamonde bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="1600"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/mc.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo Mc international bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="2000"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/mojocrack.png'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo mojocrack bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="2200"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/megamonde.jpeg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo de megamonde bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/sacg.png'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo sacg bénin"
              />
            </div>
          </div>

          <div
            class=" mb-5 mb-lg-5"
            data-aos="fade-up"
            data-aos-duration="2300"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/newdesign.png'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo New design group bénin"
              />
            </div>
          </div>

          <div class="mb-5 mb-lg-5" data-aos="fade-up" data-aos-duration="2500">
            <div class="px-4">
              <img
                v-lazy="'img/theme/tokh.jpg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo tokh bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-right"
            data-aos-duration="2400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/GARAGISTES.jpg'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo les garagistes du bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="2500"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/tok.png'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo bookonnet bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-right"
            data-aos-duration="2400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/Sens_Benin.webp'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo les garagistes du bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-right"
            data-aos-duration="2400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/TBC_Afriqua_modi.webp'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo les garagistes du bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-right"
            data-aos-duration="2400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/Excelsior.webp'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo les garagistes du bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-right"
            data-aos-duration="2400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/LOGO-ABMS-OK-Retenu-Juin-2016.webp'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo les garagistes du bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-right"
            data-aos-duration="2400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/Kouleur_dafrik.webp'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo les garagistes du bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-right"
            data-aos-duration="2400"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/Francom_modif.webp'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo les garagistes du bénin"
              />
            </div>
          </div>

          <div
            class="mb-5 mb-lg-5"
            data-aos="fade-left"
            data-aos-duration="2500"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/GAB.webp'"
                class="rounded img-center img-fluid shadow shadow-lg--hover partner"
                alt="logo les garagistes du bénin"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
};
</script>
<style scoped>
.partner {
  height: 95px;
  width: 100px;
}
</style>
<!-- rounded img-center img-fluid shadow shadow-lg--hover partner -->